/* eslint-disable max-len */
import cn from 'classnames';
import { memo, useRef, useState } from 'react';

import { ArrowDownIcon } from 'shared/constants/icons.constants';
import { withTranslation } from 'shared/helpers/i18n.helpers';

import { IconVerify } from './icon.constants';
import styles from './styles.module.scss';

const LIST = [
  {
    title: 'Make sure the project is legit',
    description: 'DYOR, check their social media, mentions from KOLs or VCs and the atmosphere within the community, verify the founders, look for mentions on community channels.',
  },
  {
    title: 'Make sure the token is legit',
    description: 'DYOR, check its price dynamics, sales history and trading volume, look for mentions on community channels.',
  },
];

const MediumRisksInfo = () => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  return (
    <div className={cn(styles.wrap, { [styles.open]: isOpen })}>
      <button className={styles.header} onClick={() => setIsOpen(!isOpen)}>
        <div className={styles.info}>
          {IconVerify}
          {withTranslation('How to verify medium risk')}
        </div>
        <ArrowDownIcon className={styles.arrow} />
      </button>
      <div
        ref={contentRef}
        style={{ maxHeight: `${!isOpen ? '0px' : `${Number(contentRef.current?.scrollHeight)}px`}` }}
        className={styles.list}
      >
        {LIST.map(({ title, description }, index) => (
          <div className={styles.item} key={title}>
            <span className={styles.index}>{index + 1}</span>
            <div className={styles.info}>
              <div className={styles.title}>{title}</div>
              <div className={styles.description}>{description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(MediumRisksInfo);
